import * as stylex from '@stylexjs/stylex';
import { Wordmark } from '~components/Logo';
import { styles } from './styles';

// The landing page's top nav, shared by every route. Self-contained (brings
// its own page-width container); ctaHref lets the landing page anchor to its
// own #get section instead of navigating.
export function SiteHeader({
  ctaHref = '/#get'
}: {
  ctaHref?: string;
}) {
  return <div {...stylex.props(styles.container)}>
      <header {...stylex.props(styles.nav)}>
        <a href="/" {...stylex.props(styles.brand)} aria-label="tribys home">
          <Wordmark height={30} />
        </a>
        <a href={ctaHref} {...stylex.props(styles.navCta)}>Get the app</a>
      </header>
    </div>;
}